import { render, staticRenderFns } from "./ProvisionalReport.vue?vue&type=template&id=527e31f3&"
import script from "./ProvisionalReport.vue?vue&type=script&lang=js&"
export * from "./ProvisionalReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports